import { Link, NavLink } from "react-router-dom";
import { useAuth } from "@lib/auth-client";

export function Navbar() {
  const { user, login, logout, loading, isAdmin } = useAuth();

  return (
    <header className="navbar">
      <div className="navbar__left">
        <Link to="/" className="navbar__brand">
          Product Intelligence
        </Link>
        <nav className="navbar__links">
          <NavLink to="/" end className={({ isActive }) => (isActive ? "active" : undefined)}>
            Home
          </NavLink>
          <NavLink to="/compare" className={({ isActive }) => (isActive ? "active" : undefined)}>
            Compare
          </NavLink>
          {isAdmin ? (
            <NavLink to="/admin" className={({ isActive }) => (isActive ? "active" : undefined)}>
              Admin
            </NavLink>
          ) : null}
        </nav>
      </div>
      <div className="navbar__right">
        {loading ? (
          <span>Loading…</span>
        ) : user ? (
          <button type="button" className="navbar__user" onClick={() => void logout()}>
            {user.avatarUrl ? <img src={user.avatarUrl} alt={user.name ?? user.email} /> : null}
            <span>{user.name ?? user.email}</span>
          </button>
        ) : (
          <button type="button" className="navbar__login" onClick={() => login()}>
            Log in with Google
          </button>
        )}
      </div>
    </header>
  );
}
